module.exports = __webpack_public_path__ + "img/prod-detail2.b160a715.jpg";